var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
export var typographyBreakpoint = "@media(max-width: 600px)";
var typography = {
    head1: (_a = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "2.5rem",
            lineHeight: "3.1rem",
            fontWeight: "bold",
            fontStyle: "none",
            textTransform: "uppercase"
        },
        _a[typographyBreakpoint] = {
            fontSize: "2.1rem",
            lineHeight: "2.55rem",
        },
        _a),
    head2: (_b = {
            fontSize: "2.3rem",
            lineHeight: "2.8rem",
            fontWeight: "bold",
            fontStyle: "none"
        },
        _b[typographyBreakpoint] = {
            fontSize: "1.9rem",
            lineHeight: "2.3rem",
        },
        _b),
    subtitle1: (_c = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "2rem",
            lineHeight: "2.5rem",
            fontWeight: "700"
        },
        _c[typographyBreakpoint] = {
            fontSize: "1.7rem",
            lineHeight: "2rem",
        },
        _c),
    subtitle2: (_d = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "2.0rem",
            lineHeight: "2.5rem"
        },
        _d[typographyBreakpoint] = {
            fontSize: "1.7rem",
            lineHeight: "2rem",
        },
        _d),
    button1: (_e = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "1.6rem",
            lineHeight: "1.95rem",
            fontWeight: "400"
        },
        _e[typographyBreakpoint] = {
            fontSize: "1.4rem",
            lineHeight: "1.7rem",
        },
        _e),
    button2: (_f = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "1.6rem",
            lineHeight: "1.95rem",
            fontWeight: "bold"
        },
        _f[typographyBreakpoint] = {
            fontSize: "1.4rem",
            lineHeight: "1.7rem",
        },
        _f),
    button3: (_g = {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "1.4rem",
            lineHeight: "1.463rem",
            fontWeight: "normal",
            textTransform: "inherit"
        },
        _g[typographyBreakpoint] = {
            fontSize: "1.3rem",
            lineHeight: "1.585rem",
        },
        _g),
    body1: (_h = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.7rem",
            lineHeight: "2.3rem"
        },
        _h[typographyBreakpoint] = {
            fontSize: "1.5rem",
            lineHeight: "2rem",
        },
        _h),
    body2: (_j = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.7rem",
            lineHeight: "2.3rem",
            fontWeight: "bold",
            fontStyle: "underline"
        },
        _j[typographyBreakpoint] = {
            fontSize: "1.5rem",
            lineHeight: "2rem",
        },
        _j),
    body3: (_k = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.5rem",
            lineHeight: "2.05rem"
        },
        _k[typographyBreakpoint] = {
            fontSize: "1.3rem",
            lineHeight: "1.8rem",
        },
        _k),
    body4: (_l = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.5rem",
            lineHeight: "2.05rem",
            fontWeight: "bold"
        },
        _l[typographyBreakpoint] = {
            fontSize: "1.3rem",
            lineHeight: "1.8rem",
        },
        _l),
    caption1: (_m = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.3rem",
            lineHeight: "1.8rem"
        },
        _m[typographyBreakpoint] = {
            fontSize: "1.1rem",
            lineHeight: "1.5rem",
        },
        _m),
    caption2: (_o = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.3rem",
            lineHeight: "1.8rem",
            fontWeight: "bold"
        },
        _o[typographyBreakpoint] = {
            fontSize: "1.1rem",
            lineHeight: "1.5rem",
        },
        _o),
    placeholder: (_p = {
            fontFamily: "'Nunito', sans-serif",
            fontSize: "1.7rem",
            lineHeight: "2.3rem",
            fontWeight: "normal",
            fontStyle: "italic"
        },
        _p[typographyBreakpoint] = {
            fontSize: "1.5rem",
            lineHeight: "2.5rem",
        },
        _p),
};
export default typography;
